export enum RouteEnum {
  // Auth
  Login = "/login",
  SignOut = "/signout-oidc",
  SignIn = "/signin-oidc",

  // Error
  Error404 = "/error-404",
  Error403 = "/error-403",
  UnexpectedError = "/unexpected-error",

  Landing = "/",
  Store = "/store",
  ContactUs = "/ContactUs",
  AboutUs = "/AboutUs",
  SiteRules = "/SiteRules",
  Cart = "/cart",
  ProductDetails = "/product-details/:type(product|service)/:id",
  Transaction = "/transaction",
  PaymentSuccess = "/wallet/success",
  PaymentFailure = "/wallet/fail",
  UserOrders = "/user-orders",
  UserOrderDetails = "/user-orders/:id",
  Library = "/library",
  LibraryDetail = "/library/:id",
  Statements = "/statements",
  StatementDetail = "/statement/:id",
  TextNews = "/news/text-news",
  TextNewDetail = "/news/text-news/:id",
  PhotoNews = "/news/photo-news",
  PhotoNewDetail = "/news/photo-news/:id",
  VideoNews = "/news/video-news",
  VideoNewDetail = "/news/video-news/:id",
}

//----------------------------------------------------------------------

// Landing
// Landing = "/",

// General
// Library = "/library",

// Election
// Election = "/Election",
// ElectionProvince = "/Election/Province",
// ElectionCounties = "/Election/Counties/:id",
// ElectionUnions = "/Election/Unions/:id",
// ElectionCandidates = "/Election/Candidates/:id",

// News
// News = "/News",

// TextNews = "/News/TextNews",
// TextNewsDetails = "/News/TextNews/:id",

// PhotoNews = "/News/PhotoNews",
// PhotoNewsDetails = "/News/PhotoNews/:id",

// VideoNews = "/News/VideoNews",
// VideoNewsDetails = "/News/VideoNews/:id",

// Statement
// Statement = "/Statement",
// Statements = "/Statement/Statements",
// StatementDetails = "/Statement/Statements/:id",

// Challenges
// Challenges = "/Challenges",
// ChallengeDetails = "/Challenges/details/:id",
// NewChallenge = "/Challenges/New",
// NewChallengeFinal = "/Challenges/New/:id",
// MyChallenges = "/Challenges/MyChallenges",
// SignedChallenges = "/Challenges/SignedChallenges",

// Store
// Store = "/store",

// Wallet
// Wallet = "/wallet",
// ChargeWallet = "/wallet/charge",
// TransactionList = "/wallet/transaction-list",
// WalletSuccess = "/wallet/success",
// WalletFail = "/wallet/fail",

// Orders
// UserOrders = "/user-orders",
// UserOrderDetails = "/user-orders/:id",
